import { IFlow } from '../interfaces/Flow';
import { UPDATE_REDIRECT_FLOW } from './actions';

export const updateRedirectFlows = (payload: Array<IFlow>) => ({
  type: UPDATE_REDIRECT_FLOW,
  payload
});